module.exports = require('./ConsumerDiscountAnnualReportView');
